module.exports = require('./ConsumerDiscountAnnualReportView');
